var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgJobRetriesReport = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18,9.875 C17.447,9.875 17,10.323 17,10.875 L17,11.257 C16.267,10.417 15.2,9.875 14,9.875 C11.794,9.875 10,11.669 10,13.875 C10,16.081 11.794,17.875 14,17.875 C14.553,17.875 15,17.427 15,16.875 C15,16.323 14.553,15.875 14,15.875 C12.897,15.875 12,14.978 12,13.875 C12,12.772 12.897,11.875 14,11.875 C14.736,11.875 15.375,12.28 15.722,12.875 L15,12.875 C14.447,12.875 14,13.323 14,13.875 C14,14.427 14.447,14.875 15,14.875 L19,14.875 L19,10.875 C19,10.323 18.553,9.875 18,9.875"
}), /*#__PURE__*/React.createElement("polyline", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  points: "10 8.75 7.5 7.5 10 0 0 8.75 5 11.25 2.5 18.75 7.5 15"
}))));
export default SvgJobRetriesReport;